import Request from './request'

const Storage = {
  getStorageDevicesList (params, callback) {
    Request.get('storage/devices', params).then(callback).catch(this.bad_answer)
  },
  getStorageComponentsList (params, callback, bad_answer) {
    Request.get('moysklad/stock?' + new URLSearchParams(params).toString()).then(callback).catch(bad_answer)
  },
}
export default Storage
